export const sentidoOptions = [
    { id: 0, label: 'Entrada' },
    { id: 1, label: 'Retorno' }
];